export const BASE64_IMAGE_PREFIX = 'data:image/png;charset=utf-8;base64,';
